import { LayoutHOC } from 'base/ui/layout/layout';
import createWarrantyReminder from './reminderWarranty';
import { masterdataRoutes } from './routes';
import createAddUpdate from './reminderWarranty/createUpdate';
import createUnfollowRemind from './UnfollowRemind';
import createAddUpdateUnfollowRemind from './UnfollowRemind/createUpdate';
import createWarrantyTimeRemind from './WarrantyTimeRemind';

export const createMasterDataPage = (layoutHOC: LayoutHOC) => {
  // -- Gửi tin nhắn nhắc nhở bảo hành - Cấu hình thời gian nhắc nhở  --------------------------------------
  const WarrantyReminder = createWarrantyReminder();
  const AddUpdate = createAddUpdate();
  const EditUpdate = createAddUpdate();

  // -- Reminđ bỏ theo dõi ----------------------------------------------------------------------------------
  const UnfollowRemind = createUnfollowRemind();
  const AddUnfollowRemind = createAddUpdateUnfollowRemind();


  const WarrantyTimeRemind = createWarrantyTimeRemind();



  const MasterdataPage = layoutHOC(masterdataRoutes);
  return () => (
    <MasterdataPage
      WarrantyReminder={WarrantyReminder}
      AddUpdate={AddUpdate}
      EditUpdate={EditUpdate}
      UnfollowRemind={UnfollowRemind}
      AddUnfollowRemind={AddUnfollowRemind}

      WarrantyTimeRemind={WarrantyTimeRemind}
    />
  );
};
